const $db6f33bdfcc5f01d$export$fb1f670b3e66577f = [
    {
        title: "E-book Website",
        image: "image/Portfolio-1.png",
        text: "Designed by Bedimcode",
        url: "https://e-bookwebsite.netlify.app/",
        github: "https://github.com/Sara-pyon/e-book_website"
    },
    {
        title: "Christmas Website",
        image: "image/Portfolio-2.png",
        text: "Designed by Bedimcode",
        url: "https://main--christmas-websitebysara.netlify.app/",
        github: "https://github.com/Sara-pyon/Christmas_website"
    },
    {
        title: "Youtube Sidebar",
        image: "image/Portfolio-3.png",
        text: "Designed by Bedimcode",
        url: "https://youtube-sidebar.netlify.app/",
        github: "https://github.com/Sara-pyon/YoutubeSideBar2"
    },
    {
        title: "Travel Website",
        image: "image/Portfolio-4.png",
        text: "Designed by Bedimcode",
        url: "https://6578bae32a5c070008dddebd--travel-websitebysara.netlify.app/",
        github: "https://github.com/Sara-pyon/Travel_website"
    },
    {
        title: "Moshify Website",
        image: "image/Portfolio-5.png",
        text: "Designed by Mosh Hamadani",
        url: "https://654af43db57e610008cca27b--moshfiedbysara.netlify.app/",
        github: "https://github.com/Sara-pyon/Sarafield"
    }
];


// ===================== Show Menu ========================================
const $77ac944da51b7354$var$menu = document.getElementById("menu"), $77ac944da51b7354$var$toggleOpen = document.getElementById("toggle-open"), $77ac944da51b7354$var$toggleClose = document.getElementById("toggle-close");
$77ac944da51b7354$var$toggleOpen.addEventListener("click", ()=>$77ac944da51b7354$var$menu.classList.add("show-menu"));
$77ac944da51b7354$var$toggleClose.addEventListener("click", ()=>$77ac944da51b7354$var$menu.classList.remove("show-menu"));
// ===================== Show Education ========================================
const $77ac944da51b7354$var$historyBtn = document.getElementById("history"), $77ac944da51b7354$var$educationBtn = document.getElementById("education"), $77ac944da51b7354$var$detailBody = document.getElementById("aboutMe-detail");
$77ac944da51b7354$var$educationBtn.addEventListener("click", ()=>$77ac944da51b7354$var$detailBody.classList.remove("show-education"));
$77ac944da51b7354$var$historyBtn.addEventListener("click", ()=>$77ac944da51b7354$var$detailBody.classList.add("show-education"));
// ===================== Portfolio Cards ========================================
const $77ac944da51b7354$var$portfolioCards = document.getElementById("portfolio-cards");
let $77ac944da51b7354$var$portfolioHTML = `<div class="swiper-wrapper">`;
(0, $db6f33bdfcc5f01d$export$fb1f670b3e66577f).forEach((item)=>{
    $77ac944da51b7354$var$portfolioHTML += `
    
    <div class="portfolio__card swiper-slide">
        <div class="portfolio__img">
            <img src="${item.image}" alt="website image">
            <div class="portfolio__git-div">
                <a target="_blank" href="${item.github}">
                <i class="ri-github-fill portfolio__git"></i>
                </a>
            </div>
        </div>
        <h3 class="portfolio__title">${item.title}</h3>
        <p class="portfolio__text">${item.text}</p>
        <a target="_blank" href="${item.url}" class='portfolio__link'>
            <button class="portfolio__btn">
                visit</button></a>
    </div>
    `;
});
$77ac944da51b7354$var$portfolioHTML += `</div> <div class="swiper-button-prev"></div>
<div class="swiper-button-next"></div>`;
$77ac944da51b7354$var$portfolioCards.innerHTML = $77ac944da51b7354$var$portfolioHTML;
// ===================== Portfolio Swiper ========================================
const $77ac944da51b7354$var$swiperHome = new Swiper(".portfolio__swiper", {
    loop: "true",
    spaceBetween: 15,
    grapCursor: true,
    slidesPerView: "auto",
    centeredSlides: "auto",
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    breakpoints: {
        1000: {
            slidesPerView: 2,
            centeredSlides: false
        }
    }
});
// ===================== Header Shadow ========================================
const $77ac944da51b7354$var$header = document.getElementById("header");
const $77ac944da51b7354$var$headerScroll = ()=>{
    const aboutMe = document.getElementById("aboutMe"), aboutTop = aboutMe.offsetTop;
    window.scrollY >= aboutTop ? $77ac944da51b7354$var$header.classList.add("header-shadow") : $77ac944da51b7354$var$header.classList.remove("header-shadow");
};
window.addEventListener("scroll", $77ac944da51b7354$var$headerScroll);
// ===================== link Active ========================================
const $77ac944da51b7354$var$sections = document.querySelectorAll(".section");
const $77ac944da51b7354$var$linkActive = ()=>{
    $77ac944da51b7354$var$sections.forEach((current)=>{
        const currentHeight = current.offsetHeight, currentTop = current.offsetTop, currentId = current.getAttribute("id"), currentClass = document.querySelector(".header__menu a[href*=" + currentId + "]");
        if (window.scrollY >= currentTop && window.scrollY < currentTop + currentHeight) currentClass.classList.add("active-link");
        else currentClass.classList.remove("active-link");
    });
};
window.addEventListener("scroll", $77ac944da51b7354$var$linkActive);
// ===================== Scroll Up Btn ========================================
const $77ac944da51b7354$var$scrollUp = ()=>{
    const scrollUp = document.getElementById("scrollUp");
    window.scrollY >= 30 ? scrollUp.classList.add("show-scrollUp") : scrollUp.classList.remove("show-scrollUp");
};
window.addEventListener("scroll", $77ac944da51b7354$var$scrollUp);
// ===================== Footer References ========================================
const $77ac944da51b7354$var$references = document.querySelector(".footer__list"), $77ac944da51b7354$var$reference = [
    {
        name: "Takehisa Hasegawa",
        post: "Professor",
        from: "(Ibaraki University, Ibaraki, Japan)",
        url: "http://takehisahasegawa.sci.ibaraki.ac.jp/",
        email: "takehisa.hasegawa.sci@vc.ibaraki.ac.jp"
    },
    {
        name: "Zoey Wang",
        post: "Restaurant Manager",
        from: "(Honjin Izakaya, Calgary, Canada)",
        mobile: "+1 587-888-3873",
        email: "zoey.kekitchen@gmail.com"
    },
    {
        name: "Dan Osborne",
        post: "Host Father (School Principal)",
        from: "(Calgary, Canada)",
        mobile: "+1 403-919-0819",
        email: "dan56@shaw.ca"
    }
];
let $77ac944da51b7354$var$referencesHTML = "";
$77ac944da51b7354$var$reference.forEach((item)=>{
    if (item.url) $77ac944da51b7354$var$referencesHTML += `
    
    <div class="footer__item">
        <div class="footer__reference">
            <a href="${item.url}" target="_blank"><i class="ri-link footer__link"></i></a>
            <div class="footer__reference">
                <h4 class="footer__name">${item.name}</h4>
                <h4 class="footer__post">${item.post}</h4>
            </div>
        </div>
        <div class="footer__contact">
            <p class="footer__from">${item.from}</p>
            <div class="footer__mail-container">
                <a href="mailto:${item.email}">
                    <i class="ri-mail-line footer__icon"></i>
                </a>
                <p class="footer__mail">${item.email}</p>
            </div>
        </div>
    </div>
    `;
    else $77ac944da51b7354$var$referencesHTML += `
    
    <div class="footer__item">
        <div class="footer__reference">
            <h4 class="footer__name">${item.name}</h4>
            <h4 class="footer__post">${item.post}</h4>
        </div>
        <div class="footer__contact">
            <p class="footer__from">${item.from}</p>
            <div class="footer__mobile-container">
                <i class="ri-phone-line footer__icon"></i>
                <p class="footer__mobile">${item.mobile}</p>
            </div>
            <div class="footer__mail-container">
                <a href="mailto:${item.email}">
                    <i class="ri-mail-line footer__icon"></i>
                </a>
                <p class="footer__mail">${item.email}</p>
            </div>
            
        </div>
    </div>
    `;
});
$77ac944da51b7354$var$references.innerHTML = $77ac944da51b7354$var$referencesHTML;


//# sourceMappingURL=index.21a58580.js.map
